import { gql } from 'graphql-request'
import { queryClient, reportGqlError, request, useMutation } from '../../api'
import { ServerOrderInput } from '../../generated/graphql-types'
import { CreateOrderFunctionResult } from './logic'
import { CloudFunctionResult } from '../responses'
import { ORDERS_QUERY_KEY } from '../order'
import { TRANSACTIONS_QUERY_KEY } from '../transaction'

export function useCreateOrderAsClient() {
  return useMutation(
    async (dto: {
      branchId: number
      paymentProviderId: string
      order: ServerOrderInput
      resultUrl?: string
    }): Promise<{
      createOrder: CreateOrderFunctionResult
    }> => {
      return request(
        gql`
          mutation (
            $branchId: Int!
            $paymentProviderId: uuid!
            $order: OrderInput!
            $resultUrl: String
          ) {
            createOrder(
              branchId: $branchId
              paymentProviderId: $paymentProviderId
              order: $order
              resultUrl: $resultUrl
            ) {
              orderId
              code
              message
              data
              signature
              pageUrl
            }
          }
        `,
        dto,
      )
    },
    {
      onError: reportGqlError,
    },
  )
}

export function usePayForOrderAsClient() {
  return useMutation(
    async (dto: {
      branchId: number
      paymentProviderId: string
      orderId: number
      resultUrl?: string
    }): Promise<{
      createOrder: CreateOrderFunctionResult
    }> => {
      return request(
        gql`
          mutation (
            $branchId: Int!
            $paymentProviderId: uuid!
            $orderId: Int!
            $resultUrl: String
          ) {
            createOrder(
              branchId: $branchId
              paymentProviderId: $paymentProviderId
              orderId: $orderId
              resultUrl: $resultUrl
            ) {
              orderId
              code
              message
              data
              signature
              pageUrl
            }
          }
        `,
        dto,
      )
    },
    {
      onError: reportGqlError,
    },
  )
}

export function useCreateRefundAsClient() {
  return useMutation(
    async (dto: {
      orderId: number
    }): Promise<{
      createRefund: CloudFunctionResult
    }> => {
      return request(
        gql`
          mutation ($orderId: Int!) {
            createRefund(orderId: $orderId, type: client) {
              code
              message
            }
          }
        `,
        dto,
      )
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([ORDERS_QUERY_KEY])
      },
      onError: reportGqlError,
    },
  )
}

export function useCreateRefundByEmployee() {
  return useMutation(
    async (dto: {
      orderId: number
      partialRefund?: number
    }): Promise<{
      createRefund: CloudFunctionResult
    }> => {
      return request(
        gql`
          mutation ($orderId: Int!, $partialRefund: Float) {
            createRefund(orderId: $orderId, partialRefund: $partialRefund, type: employee) {
              code
              message
            }
          }
        `,
        dto,
      )
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([TRANSACTIONS_QUERY_KEY])
      },
      onError: reportGqlError,
    },
  )
}
